<div class="cpcontent">
    <h2>Alarm Settings of Gas Detectors</h2>

    These are default settings as per <a href="https://www.indsci.com/en/blog/understanding-gas-detector-default-alarm-settings" target="_blank">Industrial Scientific</a>.

    <table class="table table-bordered table-striped" style="max-width:1000px">
        <tbody>
            <tr>
                <td width="20%">
                    <p><strong>GAS</strong></p>
                </td>
                <td width="20%">
                    <p><strong>LOW</strong></p>
                </td>
                <td width="20%">
                    <p><strong>HIGH</strong></p>
                </td>
                <td width="20%">
                    <p><strong>TWA</strong></p>
                </td>
                <td width="20%">
                    <p><strong>STEL</strong></p>
                </td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/oxygen-o2/?hsLang=en" target="_blank" rel="noopener"><strong>O2</strong></a></td>
                <td>19.5% vol</td>
                <td>23.5% vol</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/carbon-monoxide-co/?hsLang=en" target="_blank" rel="noopener"><strong>CO</strong></a></td>
                <td>35 ppm<sup>a, b</sup></td>
                <td>70 ppm<sup>b</sup></td>
                <td>35 ppm<sup>a</sup>&nbsp;</td>
                <td>200 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/hydrogen-sulfide-h2s/?hsLang=en" target="_blank" rel="noopener"><strong>H2S</strong></a></td>
                <td>10 ppm</td>
                <td>20 ppm</td>
                <td>10 ppm</td>
                <td>15 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/sulfur-dioxide-so2/?hsLang=en" target="_blank" rel="noopener"><strong>SO2</strong></a></td>
                <td>2.0 ppm</td>
                <td>4.0 ppm</td>
                <td>2.0 ppm</td>
                <td>5.0 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/nitrogen-dioxide-no2/?hsLang=en" target="_blank" rel="noopener"><strong>NO2</strong></a></td>
                <td>3.0 ppm</td>
                <td>6.0 ppm<sup>c</sup></td>
                <td>3.0 ppm</td>
                <td>5.0 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/chlorine-cl2/?hsLang=en" target="_blank" rel="noopener"><strong>Cl2</strong></a></td>
                <td>0.5 ppm</td>
                <td>1.0 ppm</td>
                <td>0.5 ppm</td>
                <td>1.0 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/chlorine-dioxide-clo2/?hsLang=en" target="_blank" rel="noopener"><strong>ClO2</strong></a></td>
                <td>0.1 ppm</td>
                <td>0.2 ppm</td>
                <td>0.1 ppm</td>
                <td>0.3 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/carbon-dioxide-co2/?hsLang=en" target="_blank" rel="noopener"><strong>CO2</strong></a></td>
                <td>0.5% vol</td>
                <td>1.0% vol</td>
                <td>0.5% vol</td>
                <td>3.0% vol</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/phosphine-ph3/?hsLang=en" target="_blank" rel="noopener"><strong>PH3</strong></a></td>
                <td>0.3 ppm</td>
                <td>0.6 ppm</td>
                <td>0.3 ppm</td>
                <td>1.0 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/ammonia-nh3/?hsLang=en" target="_blank" rel="noopener"><strong>NH3</strong></a></td>
                <td>25 ppm</td>
                <td>50 ppm</td>
                <td>25 ppm</td>
                <td>35 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/hydrogen-cyanide-hcn/?hsLang=en" target="_blank" rel="noopener"><strong>HCN</strong></a></td>
                <td>5.0 ppm</td>
                <td>10.0 ppm</td>
                <td>4.0 ppm</td>
                <td>4.0 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/nitric-oxide-no/?hsLang=en" target="_blank" rel="noopener"><strong>NO</strong></a></td>
                <td>25 ppm</td>
                <td>50 ppm</td>
                <td>25 ppm</td>
                <td>25 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/hydrogen-chloride-hcl/?hsLang=en" target="_blank" rel="noopener"><strong>HCl</strong></a></td>
                <td>2.5 ppm</td>
                <td>5.0 ppm</td>
                <td>2.5 ppm</td>
                <td>2.5 ppm</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/hydrogen-h2/?hsLang=en" target="_blank" rel="noopener"><strong>H2</strong></a></td>
                <td>50 ppm</td>
                <td>100 ppm</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
            <tr>
                <td><a href="https://www.indsci.com/en/gas-detectors/by-gas/methane-detectors-ch4/?hsLang=en" target="_blank" rel="noopener"><strong>CH4</strong></a></td>
                <td>1.0% vol</td>
                <td>1.5% vol</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
            <tr>
                <td><strong>LEL</strong></td>
                <td>10% LEL</td>
                <td>20% LEL</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
            <tr>
                <td><strong>PID</strong></td>
                <td>100 ppm</td>
                <td>200 ppm</td>
                <td>N/A</td>
                <td>N/A</td>
            </tr>
        </tbody>
    </table>
    <div style="max-width:1000px">
        <h5>Explanation for Gas Detectors (ChatGPT)</h5>
        Gas detectors typically use different alarm levels to indicate the presence and concentration of hazardous gases. These levels include:
        <br><br>
        <b>Low Alarm</b>: This is the first level of alarm, which signals a potentially harmful gas concentration but at a level that is not immediately dangerous. This level is set to alert users before the situation becomes hazardous.
        <br><br>
        <b>High Alarm</b>: This level is set higher than the Low Alarm and indicates a more dangerous concentration of gas. At this point, the gas levels may pose an immediate health risk, and prompt action is required.
        <br><br>
        <b>TWA (Time-Weighted Average)</b>: The TWA alarm level is based on the average exposure to a certain gas over an 8-hour work shift. This level is used to protect against the health effects of long-term exposure. If the TWA level is exceeded, it indicates that the average exposure is higher
        than the
        recommended limits.
        <br><br>
        <b>STEL (Short-Term Exposure Limit)</b>: This alarm level represents the maximum concentration of a gas to which workers can be exposed continuously for a short period (usually 15 minutes) without suffering from irritation, chronic or irreversible tissue damage, or narcosis of sufficient
        degree to
        increase the likelihood of accidental injury, impair physical or mental performance, or reduce escape capability.
        <br><br>
        
        <h5>Radiation Monitors (ChatGPT)</h5>
        The default alarm settings for radiation monitors can vary depending on the type of monitor and its intended use (e.g., industrial, medical, or environmental monitoring). However, there are generally accepted standard levels used in many devices. These levels are usually based on the dose
        rate of radiation, measured in microsieverts per hour (µSv/h) or millirems per hour (mrem/h). Here are some common default alarm settings:
        <br><br>
        <b>Low-Level Alarm:</b> This alarm is set to indicate an increased but not immediately dangerous level of radiation. It might be set around 0.5 to 1 µSv/h (0.05 in mrem/h), which is above normal background radiation levels.
        <br><br>
        <b>High-Level Alarm</b>: This alarm indicates a much higher level of radiation, suggesting an immediate danger or a significant increase in exposure. This might be set around 5 to 10 µSv/h or higher.
        <br><br>
        <b>Extremely High-Level Alarm</b>: Some monitors have a third, higher alarm setting for extremely dangerous levels of radiation. The threshold for this alarm can vary significantly based on the monitor's purpose and could be set at levels indicating a severe radiation hazard.
    </div>

</div>